export const CA_CHAT_PERMISSIONS = [
  'looker_reports.conversation.chat',
  'looker_gateway.conversation.chat',
]
